import {
  parseUtilityTypeOrAll,
  UtilityTypeOrAll,
} from 'switch-shared/modules/crud/utility/utility.enums';

interface DashboardControlState {
  utility?: UtilityTypeOrAll;
  zoneId?: string;
}

const UTILITY_PARAM = 'utility';
const ZONE_PARAM = 'zone';

export const parseDashboardControlParams = (
  params: URLSearchParams
): DashboardControlState => {
  const utilityParam = params.get(UTILITY_PARAM);
  const zoneId = params.get(ZONE_PARAM) || undefined;

  if (!utilityParam) {
    return { utility: undefined, zoneId };
  }

  try {
    return {
      utility: parseUtilityTypeOrAll(utilityParam),
      zoneId,
    };
  } catch {
    return { utility: undefined, zoneId };
  }
};

export const buildDashboardControlParams = (
  currentParams: URLSearchParams,
  state: DashboardControlState
) => {
  const nextParams = new URLSearchParams(currentParams);

  if (state.utility) {
    nextParams.set(UTILITY_PARAM, state.utility);
  } else {
    nextParams.delete(UTILITY_PARAM);
  }

  if (state.zoneId) {
    nextParams.set(ZONE_PARAM, state.zoneId);
  } else {
    nextParams.delete(ZONE_PARAM);
  }

  return nextParams;
};

export const shouldHydrateDashboardZoneFromUrl = (zoneId?: string) =>
  zoneId !== undefined;

export const resolveDashboardZoneIdForUrl = (
  urlZoneId: string | undefined,
  activeZoneId: string | undefined
) => urlZoneId ?? activeZoneId;
